<template lang="pug">
.benchmarks-how
  .how-section
    h5.benchmarks-heading How is activity calculated?
    ul
      li Activity is only recorded when the timer is running
      li Keyboard & mouse movement is stored as True/False every second
      li Activity is calculated by the percent of time with any movement
      li Keystrokes on the keyboard are never recorded
  .how-section
    h5.benchmarks-heading What affects the activity average?
    ul
      li Only timers that track activity will effect the average
      li Manual time entered does not affect the activity average
      li Projects with activity tracking OFF will not affect the average
</template>

<script>
/**
 * Cannot be functional as we use `v-show` directive,
 * and it doesn't work with functional components.
 */
export default {
  name: 'ActivitiesBenchmarksDialogHow',
};
</script>
